import React, { useState, useEffect, useRef } from "react";
import Header from "../../../Components/Header/header";
import FormHeader from "../../../Components/formHeaders/formheaders";
import Back from "../../../Components/back/back";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import "../../../css/loader.css";
import { FaPlus, FaTrash } from "react-icons/fa"; // Import the plus icon from react-icons
import config from "../../../Context/Config";
import { toJpeg } from "html-to-image";
import { jsPDF } from 'jspdf';
import AssignmentRelease from "../../../Components/assignmentRelease/assignmentRelease";
import SegAssignmentRelease from "../../../Components/assignmentRelease/segAssignmentRelease";
import FinancialPolicy from "../../../Components/financialPolicy/financialPolicy";
import SegFinancialPolicy from "../../../Components/financialPolicy/segFinancialPolicy";
import ImageConsent from "../../../Components/imageConsent/imageConsent";
import PrivacyConsent from "../../../Components/privacyPolicy/privacyPolicy";
import Refresh from "../../../Components/refresh/refresh";
import Rocket from "../../../Components/rocket/rocket";
import Writing from '../../../Components/typewriter/typewriter';
import NextBtnLoader from "../../../Components/loader/loader";
import FormInput from "../../../Components/formInput/formInput";
import SelectInput from "../../../Components/selectInput/select";
import Signature from "../../../Components/signature/signature";
import TextInput from "../../../Components/textInput/textInput";
import BackgruseRedirectIfNotLoggedIn from '../../../Components/redirect/redirect';
import { checkTokenAndNavigate } from "../../../Utils/login";
import { getCityStateFromZip } from "../../../Utils/zip";
import { uploadWithXHR } from "../../../Utils/upload";
import { loadImageSafely } from "../../../Utils/loadImages";
import MedicalPortalAccess from "../../../Components/selectInput/portal";
import DynamicCheckbox from "../../../Components/selectInput/consent";
import { languageOptions, genderOptions, emergencyRelationshipOptions, ethnicityOptions, raceOptions, maritalOptions, refractionsOptions, imagingOptions } from '../../../Utils/Options';
import { compressImageForIOS } from "../../../Utils/compress";
import { formattingDate } from "../../../Utils/formatDate";
import { waitForImages } from "../../../Utils/domUtils";
import { stitchedImages } from "../../../Utils/stitchImages";
import { handleFamilyContentChanges, removeFamilyMember, validateFamilyMembers } from "../../../Utils/familyMembers";
import DobInput from "../../../Components/dobPicker/dobInput";
import Paragraph from "../../../Components/paragraph/paragrah";
import DisabledTextBox from "../../../Components/textInput/disabledText";
import RSIRegistration from "../../../Components/Registration/rsiRegistration";
import SegRegistration from "../../../Components/Registration/segRegistration";
import segLogo from '../../../Components/Assets/seglogo.svg';
import SegTitle from "../../../Components/InfoDisplay/segTitle";
import DOBPickerInput from "../../../Components/dobPicker/dobPicker";
import CheckboxGroup from "../../../Components/selectInput/checkBox";
import SegFooter from '../../../Components/InfoDisplay/segfooter'
import SegLogoBanner from '../../../Components/InfoDisplay/segLogo';
import FamilyDiseases from '../../../Components/selectInput/familyDiseases';
import ABN from "../../../Components/abn/abn";
import SegimageConsentForm from "../../../Components/imageConsent/segImageConsent";
import Head from '../../../Components/InfoDisplay/header';
import RadioGroup from "../../../Components/radio/radio";
import { useZoom } from "../../../Context/Zoom";
import FamilyMemberConsent from "../../../Components/familyMembers/familyMembers";
import { autosave } from "../../../Utils/autosave";
import useBackLock from "../../../Utils/backLock"
import SymptomCheckboxGroup from "../../../Components/selectInput/medselect";
import optos from "../../../Components/Assets/optos.png";
import optosHeader from "../../../Components/Assets/optosHeader.png";
import Logo from '../../../Components/InfoDisplay/logo';
import { showAlertAndNavigate } from "../../../Utils/swal";
import Agree from "../../../Components/signature/agree";


const PatientRegistrationPageForm = () => {
  useBackLock()
  const { zoom, setZoom } = useZoom();
  const [nextLoader, setNextLoader] = useState(false);
  const location = useLocation();
  const { openedViaLogin, show, chart, apptId } = location.state || {};
  BackgruseRedirectIfNotLoggedIn(openedViaLogin, 50, "/context-not-found");
  const [isUploading, setIsUploading] = useState(false);
  const dept_practice = config.practice;
  const navigate = useNavigate();
  const [pageTitle, setPageTitle] = useState("");
  const [subPageTitle, setSubPageTitle] = useState("");
  const [currentPage, setCurrentPage] = useState((dept_practice === 'seg' && !show) || dept_practice == 'rsi' ? 0 : 7);
  const currentDate = new Date();
  const [isDisabled, setIsDisabled] = useState(false);
  const [showPatientSignature, setShowPatientSignature] = useState(false);
  const [showPatientSignaturePage4, setShowPatientSignaturePage4] = useState(false);
  const [showPatientSignaturePage5, setShowPatientSignaturePage5] = useState(false);
  const [showPatientSignaturePage6, setShowPatientSignaturePage6] = useState(false);
  const [isLoading4, setIsLoading4] = useState(false);
  const [localpatientid, setlocalpatientid] = useState("");

  // Enhanced image loading with better error handling
  const formatDate = (date) => {
    try {
      const formattedDate = formattingDate(date);
      return formattedDate
    } catch (err) {
      console.error('Error formatting date:', err.message);
    }
  };
  const formattedDate = formatDate(currentDate); // Formats current date
  const taskRunRef = useRef(false);
  const totalPages = 8;
  const [pages, setPages] = useState(Array(totalPages).fill(null));
  const pageRefs = useRef(
    Array(totalPages)
      .fill(null)
      .map(() => React.createRef())
  );
  // Formatted current date using the formatDate function
  const [isNext, setIsNext] = useState(false);
  const [isLast, setIsLast] = useState(false);
  const [invalidFields, setInvalidFields] = useState([]);
  const [age, setAge] = useState("");
  const [signatures, setSignatures] = useState({
    responsiblePersonSignature: "",
    patientSignature: "",
    doctorSignature: "",
  });
  const canvasRefs = {
    responsiblePersonSignature: useRef(null),
    patientSignature: useRef(null),
    doctorSignature: useRef(null),
  };
  const [isLoading3, setIsLoading3] = useState(false);
  const [isEditing, setIsEditing] = useState({});


  const [PatientRegistrationFormData, setPatientRegistrationFormData] =
    useState({
      firstName: "",
      lastName: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      ssn: "",
      gender: "",
      dob: "",
      consentToText: "",
      portal: "",
      originalPortal: "",
      email: "",
      no_email: "",
      homephone: "",
      cellphone: "",
      language: "",
      ethnicity: "",
      maritalStatus: "",
      referredBy: "",
      familyDoctor: "",
      parentspouse: "",
      employee: "",
      employeeEmail: "",
      workphone: "",
      employeeExtn: "1",
      emergencyName: "",
      emergencyRelationship: "",
      emergencyPhone: "",
      patientSignature: "",
      responsiblePersonSignature: "",
      responsiblePersonRelationship: "",
      doctorSignature: "",
      familyMembers: [{ name: "", relationship: "", dob: "", mobile_number: "" }],
      insurance_data: {
        "primary_company": '',
        "primary_holdername": '',
        "primary_policy": '',
        "primary_dob": '',
        "secondary_company": '',
        "secondary_holdername": '',
        "secondary_policy": '',
        "secondary_dob": '',
      },
      symptoms: {
        "Blurred Vision": null,
        "Chest Pain": null,
        "Diarrhea": null,
        "Fatigue": null,
        "Headache": null,
        "Dizziness": null,
        "Pain in Joints": null,
        "Paralysis of Extremities": null,
        "Shortness of Breath": null,
        "Runny Nose": null,
        "Sore Throat/Cough": null,
        "Bloody Stools": null,
        "Fever": null,
        "Nausea/Vomiting": null,
        "Pain with Urination": null,
        "Frequent Urination": null,
        "Rash": null,
        "Sudden Vision Loss": null,
      },
      medicalHistory: {
        Blindness: null,
        Cataract: null,
        Glaucoma: null,
        "Macular Degeneration": null,
        "Retinal Detachment": null,
        Arthritis: null,
        Cancer: null,
        Diabetes: null,
        "Cardiac/Vascular Disease": null,
        Stroke: null,
        "Thyroid Disease": null,
        "High Blood Pressure": null,
        "Kidney Stones": null,
        "Stomach Ulcer": null,
        "Asthma/Emphysema": null,
        "AIDS/HIV": null,
      },
      familyDiseases: {
        "Blindness": { hasDisease: null, relationship: null },
        "Cataract": { hasDisease: null, relationship: null },
        "Glaucoma": { hasDisease: null, relationship: null },
        "Macular Degeneration": { hasDisease: null, relationship: null },
        "Retinal Detachment": { hasDisease: null, relationship: null },
        "Arthritis": { hasDisease: null, relationship: null },
        "Cancer": { hasDisease: null, relationship: null },
        "Diabetes": { hasDisease: null, relationship: null },
        "Heart Attacks": { hasDisease: null, relationship: null },
        "High Blood Pressure": { hasDisease: null, relationship: null },
        "Kidney Disease": { hasDisease: null, relationship: null },
        "Stroke": { hasDisease: null, relationship: null },
        "Thyroid Disease": { hasDisease: null, relationship: null }
      },
      reviewed: "",
      smoker: "",
      packsPerDay: "",
      smokedInPast: "",
      drinksAlcohol: "",
      glassesPerDay: "",
      isMarried: "",
      doYouDrive: "",
      medication: "",
      allergies: "",
      imageConsent: "",
      other_important_information: "",
      hospitalized: "",
      residing_facility: "",
      facility_name: "",
      nursing_facility: "",
      age: "",
      isMinor: "",
      hear: "",
      retired: "",
      vision: {
        "vision_insurance": "",
        "vision_policy_holder_name": "",
        "ssn_last_4_digits": "",
        "vision_dob": ""
      },
      communication: {
        name: "",
        dob: "",
        address: "",
        phone: "",
      },
      lasik: {
        "Yes, I would like to learn more": null,
        "I am unsure, please provide more information": null,
        "No, I am not interested at this time": null
      },
      last_visit_date: "",
      location: "",
      primary_doctor: "",
      pharmacy: "",
      pharm_location: "",
      seg_meds: {
        "Flomax": "",
        "Coumadin": "",
        "Plavix": "",
        "Aspirin": "",
        "Rapaflo": "",
        "Uroxatra": "",
        "Minipress": "",
        "Cardura": "",
        "Hytrin": "",
        "Avodart": ""
      },
      procedures: {
        "Lasik": "",
        "ORK": "",
        "PRK": "",
        "Cataract Surgery": "",
        "Other": "",
      },
      other_procedures: "",
      illnesses: "",
      pregnant: "",
      due_date: "",
      conditions: {
        "Cardiovascular": [
          { "name": "Chest Pain", "checked": false },
          { "name": "High Blood Pressure", "checked": false },
          { "name": "Irregular/Rapid Heartbeat", "checked": false },
          { "name": "N/A", "checked": false }
        ],
        "General": [
          { "name": "Fever", "checked": false },
          { "name": "Fatigue", "checked": false },
          { "name": "Shortness of Breath", "checked": false },
          { "name": "N/A", "checked": false }
        ],
        "Ears/Nose/Throat": [
          { "name": "Earache", "checked": false },
          { "name": "Nasal Congestion", "checked": false },
          { "name": "Pain", "checked": false },
          { "name": "N/A", "checked": false }
        ],
        "Gastrointestinal": [
          { "name": "Reflux", "checked": false },
          { "name": "Diarrhea", "checked": false },
          { "name": "Irregular/Rapid Heartbeat", "checked": false },
          { "name": "N/A", "checked": false }
        ],
        "Genitourinary": [
          { "name": "Trouble Urinating", "checked": false },
          { "name": "Discharge", "checked": false },
          { "name": "Ulcer", "checked": false },
          { "name": "N/A", "checked": false }
        ],
        "Integumentary": [
          { "name": "Skin Cancer", "checked": false },
          { "name": "Acne", "checked": false },
          { "name": "Rosacea", "checked": false },
          { "name": "Eczema", "checked": false },
          { "name": "N/A", "checked": false }
        ],
        "Musculoskeletal": [
          { "name": "Arthritis", "checked": false },
          { "name": "Gout", "checked": false },
          { "name": "Joint or Muscle Pain", "checked": false },
          { "name": "N/A", "checked": false }
        ],
        "Neurological": [
          { "name": "Numbness", "checked": false },
          { "name": "Memory Loss", "checked": false },
          { "name": "Dizziness", "checked": false },
          { "name": "Stroke", "checked": false },
          { "name": "N/A", "checked": false }
        ],
        "Psychiatric": [
          { "name": "Anxiety", "checked": false },
          { "name": "Depression", "checked": false },
          { "name": "N/A", "checked": false }
        ],
        "Endocrine": [
          { "name": "Diabetes", "checked": false },
          { "name": "Hypothyroidism", "checked": false },
          { "name": "Grave's Disease", "checked": false },
          { "name": "N/A", "checked": false }
        ],
        "Hematologic": [
          { "name": "Anemia", "checked": false },
          { "name": "High Cholesterol", "checked": false },
          { "name": "Bleeding Disorder", "checked": false },
          { "name": "N/A", "checked": false }
        ],
        "Immunologic": [
          { "name": "Allergies", "checked": false },
          { "name": "Immune Disorders", "checked": false },
          { "name": "HIV/AIDS", "checked": false },
          { "name": "Hep C", "checked": false },
          { "name": "N/A", "checked": false }
        ]
      },
      refractions: null,
      imaging_options: null,
      provider: null,
      amount: null
    });

  const toggleCheckbox = (category, index) => {
    setPatientRegistrationFormData((prev) => {
      const updated = { ...prev };
      updated[category][index].checked = !updated[category][index].checked;
      return updated;
    });
  };

  // Function to handle API call
  const runTask = async () => {
    setIsLoading4(true);
    if (taskRunRef.current) return; // Prevent running if task has already been executed
    taskRunRef.current = true;

    try {
      const response = await fetch(`${config.API_BASE_URL}/token_pat_data`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          Authorization: config.accessToken
        },
      });

      if (response.ok) {
        let data = await response.json();
        const dbData = data?.db_data ?? {};
        const patientId = data?.localpatientid ?? chart;
        setlocalpatientid(patientId);
        setPatientRegistrationFormData(prevState => ({
          ...prevState, // Retain existing fields
          firstName: data['firstname'] || "",
          lastName: data['lastname'] || "",
          address: data['address1'] || "",
          gender: data['sex'] || "",
          zip: data['zip'] || "",
          city: data['city'] || "",
          state: data['state'] || "",
          cellphone: (data['mobilephone'] || "").toString().trim(),
          language: data['language6392code'] || "",
          email: data['email'] || "",
          race: data?.race?.[0] || "",
          emergencyName: data['contactname'] || "",
          emergencyRelationship: data['contactrelationship'] || "",
          emergencyPhone: (data['contactmobilephone'] || "").toString().trim(),
          ssn: data['ssn'] || "",
          dob: data['dob'] || prevState.dob, // Preserve existing value if not in `data`
          ethnicity: (data?.ethnicitycodes?.[0]) || prevState.ethnicity,
          familyMembers: data['family_data'] || prevState.familyMembers,
          consentToText: data['consenttotext'] || prevState.consentToText,
          employee: dbData.employee ?? "",
          workphone: (data['workphone'] || "").toString().trim(),
          maritalStatus: data['maritalstatus'] || "",
          portal: data['portalstatus']['registered'] || "",
          originalPortal: data['portalstatus']['registered'],
          employeeExtn: "1",
          homephone: (data['homephone'] || "").toString().trim(),
          referredBy: dbData.referred_by ?? "",
          familyDoctor: dbData.family_doctor ?? "",
          parentspouse: dbData.parentspouse ?? "",
          employeeEmail: dbData.employee_email ?? "",
          patientSignature: dbData.patient_signature ?? "",
          hear: dbData.hear ?? "",
          responsiblePersonSignature: dbData.responsible_person_signature ?? "",
          responsiblePersonRelationship: dbData.responsible_person_relationship ?? "",
          symptoms: dbData.symptoms ?? prevState.symptoms,
          conditions: dbData.conditions ?? prevState.conditions,
          vision: dbData.vision ?? prevState.vision,
          seg_meds: dbData.seg_meds ?? prevState.seg_meds,
          procedures: dbData.procedures ?? prevState.procedures,
          communication: dbData.communication ?? prevState.communication,
          insurance_data: dbData.insurance_data ?? prevState.insurance_data,
          medicalHistory: dbData.medical_history ?? prevState.medicalHistory,
          familyDiseases: dbData.family_diseases ?? prevState.familyDiseases,
          smoker: dbData.smoker ?? "",
          other_procedures: dbData.other_procedures ?? "",
          illnesses: dbData.illnesses ?? "",
          hospitalized: dbData.hospitalized ?? "",
          retired: dbData.retired ?? "",
          residing_facility: dbData.residing_facility ?? "",
          facility_name: dbData.facility_name ?? "",
          nursing_facility: dbData.nursing_facility ?? "",
          packsPerDay: dbData.packs_per_day ?? "",
          smokedInPast: dbData.smoked_in_past ?? "",
          drinksAlcohol: dbData.drinks_alcohol ?? "",
          glassesPerDay: dbData.glasses_per_day ?? "",
          isMarried: dbData.is_married ?? "",
          doYouDrive: dbData.do_you_drive ?? "",
          medication: dbData.medication ?? "",
          surgeries: dbData.surgeries ?? "",
          other_important_information: dbData.other_important_information ?? "",
          allergies: dbData.allergies ?? "",
          imageConsent: dbData.image_consent ?? "",
          last_visit_date: dbData.last_visit_date ?? "",
          location: dbData.location ?? "",
          primary_doctor: dbData.primary_doctor ?? "",
          pharmacy: dbData.pharmacy ?? "",
          pharm_location: dbData.pharm_location ?? "",
        }));
        setSignatures((prev) => ({
          ...prev,
          patientSignature: dbData.patient_signature ?? "",
        }));
        setSignatures((prev) => ({
          ...prev,
          responsiblePersonSignature: dbData.responsible_person_signature ?? "",
        }));

      }
      else {
        // Handle different error scenarios
        // Use it like this
        showAlertAndNavigate(
          "warning",
          "Unauthorized",
          "Your session expired. Redirecting to login...",
          config.token
        );
      }
    } finally {
      // Reset loading state
      setIsLoading4(false);
    }
  };


  useEffect(() => {
    if (openedViaLogin && !taskRunRef.current) {
      checkTokenAndNavigate(runTask, navigate);
    }
  }, [openedViaLogin]);

  const handleCheckChange = (key, value) => {
    setPatientRegistrationFormData((prev) => ({
      ...prev,
      [key]: value, // Dynamically set the key with the value
    }));
  };


  const handleAddMember = () => {
    const familyMembers = PatientRegistrationFormData.familyMembers;
    const lastMember = familyMembers[familyMembers.length - 1];

    // Check if the last member is completely empty
    const allEmpty = Object.values(lastMember).every(
      (value) => !value?.toString().trim()
    );

    if (allEmpty) {
      Swal.fire({
        title: "Incomplete Member",
        text: "Please fill in all required fields for the current family member before adding another.",
        icon: "warning",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      return; // Prevent adding new member
    }

    // Validate the last member
    const errorMsg = validateFamilyMembers([lastMember]);
    if (errorMsg) {
      Swal.fire({
        title: "Missing/Invalid Fields",
        text: errorMsg,
        icon: "warning",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      return; // Prevent adding new member
    }

    // Add a new empty member
    setPatientRegistrationFormData({
      ...PatientRegistrationFormData,
      familyMembers: [
        ...familyMembers,
        { name: "", relationship: "", dob: "", mobile_number: "" },
      ],
    });
  };


  const stitchImages = async (images) => {
    try {
      const stitchedBase64 = await stitchedImages(images);
      return stitchedBase64
    } catch (err) {
      console.error("Error stitching images:", err);
    }
  };

  const toggleEditMode = (type, editMode) => {
    clearSignature(type);
    setIsEditing((prev) => ({
      ...prev,
      [type]: editMode,
    }));
  };

  const updateSignatureData = (type) => {
    const canvas = canvasRefs[type].current;
    if (canvas) {
      const dataUrl = canvas.toDataURL(0.3);
      setSignatures((prev) => ({
        ...prev,
        [type]: dataUrl,
      }));
      setPatientRegistrationFormData((prev) => ({
        ...prev,
        [type]: dataUrl, // Temporarily store in original format
      }));
    }
  };

  const clearSignature = (type) => {
    const canvas = canvasRefs[type]?.current;

    if (canvas) {
      // Clear the canvas if it exists
      canvas.clear();
    }

    // Clear the signature data from states
    setSignatures((prev) => ({
      ...prev,
      [type]: "",
    }));

    setPatientRegistrationFormData((prev) => ({
      ...prev,
      [type]: "", // Remove signature from form data
    }));

    // Optionally, exit edit mode if in edit mode
    setIsEditing((prev) => ({
      ...prev,
      [type]: false,
    }));
  };


  const handleCheckboxChange = (category, item, value) => {
    setPatientRegistrationFormData((prevState) => ({
      ...prevState,
      [category]: {
        ...prevState[category],
        [item]: value,
      },
    }));
  };

  const handleZipSearch = async () => {
    const zip = PatientRegistrationFormData.zip;
    const result = await getCityStateFromZip(zip);
    if (result) {
      setPatientRegistrationFormData({
        ...PatientRegistrationFormData,
        city: result.city,
        state: result.state,
      });
    } else {
      setPatientRegistrationFormData({
        ...PatientRegistrationFormData,
        city: '',
        state: '',
      });
    }
  }

  const handleFamilyHistoryChange = (section, disease, field, value) => {
    setPatientRegistrationFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [disease]: {
          ...prev[section][disease],
          [field]: value,
        },
      },
    }));
  };


  const handleLastPage = async () => {
    setIsLast(true);
    const image = await capturePageAsImage(currentPage);
    setIsLast(false);
    return image;

  };


  // iOS-compatible upload function
  const uploadImageIOS = async (base64Image, url, maxRetries = 3) => {

    // Compress image first
    const compressedImage = await compressImageForIOS(base64Image, 0.8, 1200);

    // Convert to binary
    const base64Data = compressedImage.replace(/^data:image\/\w+;base64,/, "");
    const binaryData = atob(base64Data);
    const arrayBuffer = new Uint8Array(binaryData.length);

    for (let i = 0; i < binaryData.length; i++) {
      arrayBuffer[i] = binaryData.charCodeAt(i);
    }

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {

        const blob = new Blob([arrayBuffer], { type: 'image/jpeg' });

        // Try fetch first
        try {
          const uploadResponse = await fetch(url, {
            method: "PUT",
            body: blob,
            headers: {
              "Content-Type": "image/jpeg",
            },
            keepalive: false,
            cache: 'no-cache',
          });

          if (uploadResponse.ok) {
            return uploadResponse;
          } else {
            throw new Error(`Fetch failed with status: ${uploadResponse.status}`);
          }
        } catch (fetchError) {

          // Fallback to XMLHttpRequest
          const uploadResponse = await new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();

            xhr.upload.addEventListener('progress', (e) => {
              if (e.lengthComputable) {
                const percentComplete = (e.loaded / e.total) * 100;
              }
            });

            xhr.addEventListener('load', () => {
              if (xhr.status >= 200 && xhr.status < 300) {
                resolve(xhr);
              } else {
                reject(new Error(`XHR failed with status: ${xhr.status}`));
              }
            });

            xhr.addEventListener('error', () => reject(new Error('XHR network error')));
            xhr.addEventListener('abort', () => reject(new Error('XHR upload cancelled')));

            xhr.open('PUT', url);
            xhr.setRequestHeader('Content-Type', 'image/jpeg');
            xhr.timeout = 120000; // 2 minutes
            xhr.send(blob);
          });

          return uploadResponse;
        }

      } catch (error) {

        if (attempt === maxRetries) {
          throw error;
        }

        // Wait before retry
        const delay = Math.pow(2, attempt) * 1000;
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    }
  };

  // Enhanced image loading with better error handling
  const imageLoading = async (src) => {
    try {
      const img = await loadImageSafely(src);
      return img
    } catch (err) {
      console.error('Error loading image:', err.message);
    }
  };

  // Enhanced PDF generation with better error handling
  const generatePaperworkPDF = async (images, localpatientid, apptId) => {

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });

    const pageWidth = 595.28;
    const pageHeight = 841.89;

    for (let i = 0; i < images.length; i++) {
      try {
        const img = await imageLoading(images[i]);

        // Calculate dimensions to fit page while maintaining aspect ratio
        const imgRatio = img.width / img.height;
        const pageRatio = pageWidth / pageHeight;

        let drawWidth, drawHeight;
        if (imgRatio > pageRatio) {
          drawWidth = pageWidth;
          drawHeight = pageWidth / imgRatio;
        } else {
          drawHeight = pageHeight;
          drawWidth = pageHeight * imgRatio;
        }

        const x = (pageWidth - drawWidth) / 2;
        const y = (pageHeight - drawHeight) / 2;

        if (i > 0) pdf.addPage();
        pdf.addImage(img, "JPEG", x, y, drawWidth, drawHeight);


      } catch (error) {
        throw new Error(`Failed to add image ${i + 1} to PDF: ${error.message}`);
      }
    }

    const pdfBlob = pdf.output("blob");
    const filename = `${localpatientid}-paperwork.pdf`;

    return { pdfBlob, filename };
  };

  const handleUpload = async (url, blob) => {
    try {
      const response = await uploadWithXHR(url, blob);
    } catch (err) {
    }
  };

  const uploadDemographicsPDF = async (pdfBlob, url) => {

    try {
      // Method 1: Try standard fetch first
      const uploadResponse = await fetch(url, {
        method: "PUT",
        body: pdfBlob,
        headers: {
          "Content-Type": "application/pdf"
        }
      });

      if (!uploadResponse.ok) {
        throw new Error(`Fetch upload failed: ${uploadResponse.status}`);
      }

    } catch (fetchError) {

      try {
        // Method 2: Try XMLHttpRequest for iOS compatibility
        const uploadResponse = await handleUpload(url, pdfBlob);
      } catch (xhrError) {
        throw new Error(`All upload methods failed. Last error: ${xhrError.message}`);
      }
    }
  };

  const handlePatientRegistration = async (e) => {
    e.preventDefault();
    const dept =
      dept_practice;

    const shouldValidate =
      (dept === "rsi" && currentPage === 7) ||
      (dept === "seg" &&
        ((show && currentPage === 6) ||
          (!show && currentPage === 5)));

    if (shouldValidate) {
      const isValid = validateForm(currentPage);
      if (!isValid) return;
    }


    // Reduce delay for iOS
    await new Promise(resolve => setTimeout(resolve, 100));
    // Save current zoom
    const originalZoom = zoom;

    // Reset zoom to 100% before capture
    setZoom(1);

    const capturedPage = await handleLastPage();
    setZoom(originalZoom); // restore
    setIsUploading(true);

    let fileArray;

    try {
      if (dept_practice === "rsi") {
        fileArray = PatientRegistrationFormData.imageConsent === "true"
          ? [
            "paperwork",
            "image_consent",
            "financial_resp",
          ]
          : [
            "paperwork",
            "financial_resp"
          ];
      }
      else {
        fileArray = [
          "paperwork"
        ];
        if (show) {
          fileArray.push("abn")
          fileArray.push("optos")
        }
      }

      const response = await fetch(`${config.API_BASE_URL}/update_db`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: config.accessToken,
        },
        body: JSON.stringify({
          form: PatientRegistrationFormData
        }),
      });


      if (!response.ok) {
        showAlertAndNavigate(
          "warning",
          "Unauthorized",
          "Your session expired. Redirecting to login...",
          config.token
        );
      }

      let data;
      try {
        data = await response.json();
      } catch (error) {
        console.error("Error parsing JSON:", error);
        Swal.fire({
          icon: "error",
          title: "Invalid Response",
          text: "The server response was not in the expected format. Please try again later.",
          confirmButtonText: "Close",
          allowOutsideClick: false,
        });
        return;
      }

      const { urls, keys } = data.presigned_url || {};
      if (!urls || urls.length === 0) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No URLs returned from the server. Please try again later.",
          confirmButtonText: "Close",
          allowOutsideClick: false,
        });
        return;
      }



      // iOS-optimized upload process
      const uploadPromises = async () => {
        const uploadTasks = urls.map(async (url, index) => {
          let base64Image;
          let imageArray = [];
          let pdf;
          let fileIndexName;

          if (dept_practice === "rsi") {
            try {
              if (index === 1) {
                base64Image = PatientRegistrationFormData.imageConsent === "true" ? pages[6] : capturedPage;
                fileIndexName = PatientRegistrationFormData.imageConsent === "true" ? 'image_consent' : 'financial_resp';
              } else if (index === 2) {
                base64Image = capturedPage;
                fileIndexName = 'financial_resp';
              }
              else if (index === 0) {
                const stitched1 = await stitchImages([pages[0], pages[1]]);
                imageArray.push(stitched1);
                imageArray.push(pages[2]);
                imageArray.push(pages[3]);
                imageArray.push(pages[4]);
                imageArray.push(pages[5]);
                const { pdfBlob } = await generatePaperworkPDF(imageArray, localpatientid, apptId)
                pdf = pdfBlob
                fileIndexName = 'paperwork';
              }

              if (fileIndexName === 'paperwork') {
                await uploadDemographicsPDF(pdf, url);
              }
              else {
                // Use iOS-compatible upload
                await uploadImageIOS(base64Image, url);

              }
              return { success: true, url, fileIndexName };

            } catch (error) {
              return { success: false, url, error, fileIndexName };
            }
          }
          if (dept_practice === "seg") {
            try {
              if (index === 1) {
                base64Image = capturedPage;
                fileIndexName = 'abn';
              } else if (index === 2) {
                base64Image = pages[7];
                fileIndexName = 'optos';
              }
              else if (index === 0) {
                const stitched1 = await stitchImages([pages[0], pages[1]]);
                imageArray.push(stitched1);
                imageArray.push(pages[2]);
                imageArray.push(pages[3]);
                imageArray.push(pages[4]);
                if (show) {
                  imageArray.push(pages[5]);
                }
                else {
                  imageArray.push(capturedPage);
                }
                const { pdfBlob } = await generatePaperworkPDF(imageArray, localpatientid, apptId)
                pdf = pdfBlob
                fileIndexName = 'paperwork';
              }

              if (fileIndexName === 'paperwork') {
                await uploadDemographicsPDF(pdf, url);
              }
              else {
                // Use iOS-compatible upload
                await uploadImageIOS(base64Image, url);

              }
              return { success: true, url, fileIndexName };

            } catch (error) {
              return { success: false, url, error, fileIndexName };
            }
          }

        }
        )

        // Process uploads with some concurrency but not all at once (iOS memory management)
        const results = [];
        const batchSize = 2; // Process 2 uploads at a time

        for (let i = 0; i < uploadTasks.length; i += batchSize) {
          const batch = uploadTasks.slice(i, i + batchSize);
          const batchResults = await Promise.all(batch);
          results.push(...batchResults);

          // Small delay between batches for iOS
          if (i + batchSize < uploadTasks.length) {
            await new Promise(resolve => setTimeout(resolve, 500));
          }
        }

        return results;
      };

      const results = await uploadPromises();
      const failedUploads = results.filter((result) => !result.success);

      if (failedUploads.length > 0) {

        const failedFileNames = failedUploads.map((fail) => fail.fileIndexName || 'Unknown').join(', ');

        Swal.fire({
          icon: "error",
          title: "Upload Failed",
          text: `Some files failed to upload: ${failedFileNames}`,
          html: `
          <div style="text-align: left;">
            <p><strong>Failed files:</strong> ${failedFileNames}</p>
            <p style="font-size: 12px; color: #666;">
              This may be due to network issues or file size. The upload will be retried.
            </p>
          </div>
        `,
          confirmButtonText: "Retry",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          allowOutsideClick: false,
        }).then(async (result) => {
          if (result.isConfirmed) {
            // Retry after short delay
            setTimeout(() => handlePatientRegistration(e), 1000);
          }
        });
      } else {

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Patient registration completed successfully.",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        }).then(() => {
          navigate(`/form-submission-success`, { state: { openedViaLogin: true } });
        });
      }

    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "There was an issue connecting to the server. Please try again.",
        html: `
        <div style="text-align: left; font-size: 12px;">
          <strong>Error details:</strong> ${error.message}<br>
          <strong>Please screenshot this and report to support if the issue persists.</strong>
        </div>
      `,
        confirmButtonText: "Retry",
        cancelButtonText: "Close",
        showCancelButton: true,
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => handlePatientRegistration(e), 1000);
        }
      });
    } finally {
      setIsUploading(false);
    }
  };


  useEffect(() => {
    // Define titles for different pages
    const titles = {
      0: "Patient Details",
      1: "Patient Details",
      2: "Assignment And Release",
      3: "Medical History Questionnaire",
      4: "Medical History Questionnaire",
      5: "Acknowledgement of Receipt of Notice of Privacy Practices",
      6: "Consent For The Release Of Images For Retina Specialty Institute Photographer Equipment Certification And Research Purposes",
      7: "Financial Responsibility Consent"
    };

    // Set the title based on the current page
    setSubPageTitle(titles[currentPage]);
  }, [currentPage, setSubPageTitle]); // Run this effect whenever `currentPage` or `setTitle` changes

  useEffect(() => {
    // Set the title based on the current page
    setPageTitle("Patient Registration Form");
  }, [setPageTitle]); // Run this effect whenever `currentPage` or `setTitle` changes

  const ButtonGroup = ({
    isDisabled,
    currentPage,
    handleEdit,
    handleNext,
    handleSubmit,
    handleBack,
    handlePatientRegistration,
  }) => {
    const buttonClass =
      "px-6 py-3 bg-sky-600 text-white rounded-lg shadow-md hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-opacity-50 transition-all";
    const dept =
      dept_practice;

    const shouldShowRegisterButton =
      (dept === "seg" &&
        (
          (!show && currentPage === 5) ||
          (show && currentPage === 6)
        )
      ) ||
      (dept === "rsi" && currentPage === 7);

    return (
      <div className="flex justify-end space-x-2 p-5 pt-0">

        {shouldShowRegisterButton ? (
          <button onClick={handlePatientRegistration} className={buttonClass}>
            <i className="fas fa-user-plus mr-2"></i> Register Patient
          </button>
        ) : (
          <>

            {
              ((!show && currentPage !== 0) || (show && currentPage !== 7)) && (
                <button
                  type="button"
                  onClick={handleBackClick}
                  className={buttonClass}
                  id="back"
                >
                  <i className="fas fa-arrow-left mr-2"></i> Previous
                </button>
              )
            }
            <button
              type="button"
              onClick={handleNext}
              className={buttonClass}
              id="next"
            >
              <i className="fas fa-arrow-right mr-2"></i> Next
            </button>

          </>
        )}
      </div>
    )

  };


  const handleInputChange = (e) => {
    const { id, value } = e.target;
    if (id === "portal" && value == "true") {
      setPatientRegistrationFormData((prev) => ({
        ...prev,
        no_email: false
      }));
    }

    setPatientRegistrationFormData((prev) => ({
      ...prev,
      [id]: id === "portal" ? value === "true" : value,
    }));

  };

  const PATTERNS = {
    ssn: /^\d{3}-\d{2}-\d{4}$|^\d{9}$/,
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    phone: (value, country = "US") => {
      if (/[a-zA-Z]/.test(value)) return false;

      const parsed = parsePhoneNumberFromString(value, country);
      return parsed?.isValid() || false;
    },
  };

  const validatePage1 = () => {
    // Define required fields
    const REQUIRED_FIELDS = [
      // { field: "email", label: "Email" },
      { field: "firstName", label: "First Name" },
      { field: "lastName", label: "Last Name" },
      { field: "address", label: "Address" },
      { field: "city", label: "City" },
      { field: "state", label: "State" },
      { field: "zip", label: "Zip" },
      { field: "dob", label: "Date of Birth" },
      { field: "gender", label: "Gender" },
    ];

    if (dept_practice === 'rsi') {
      REQUIRED_FIELDS.push({ field: "referredBy", label: "Referred By" });
      REQUIRED_FIELDS.push({ field: "familyDoctor", label: "Family Doctor" });
    }

    // Reset invalid fields
    setInvalidFields([]);
    const invalidFields = [];

    // Validate required fields
    REQUIRED_FIELDS.forEach(({ field, label }) => {
      const value = PatientRegistrationFormData[field];
      if (!String(value || "").trim()) {
        invalidFields.push(label);
      }
    });

    // Extract relevant data
    const {
      homephone,
      cellphone,
      ssn,
      email,
      portal,
      dob
    } = PatientRegistrationFormData;


    if (dob) {
      const dobRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
      if (!dobRegex.test(dob)) {
        invalidFields.push("DOB");
      } else {
        const [month, day, year] = dob.split("/").map(Number);
        const dobDate = new Date(year, month - 1, day);
        const today = new Date();
        const minDate = new Date(today.getFullYear() - 125, today.getMonth(), today.getDate());

        if (dobDate > today || dobDate < minDate) {
          invalidFields.push("DOB");
        }
      }
    }

    // Validate Home Phone (if provided)
    if (homephone && !PATTERNS.phone(homephone)) {
      invalidFields.push("Home Phone");
    }

    // Validate Cell Phone
    if (!PATTERNS.phone(cellphone)) {
      invalidFields.push("Cell Phone");
    }

    // Validate email
    if (portal === true && (!email || !PATTERNS.email.test(email))) {
      invalidFields.push("Email");
    } else if (email && !PATTERNS.email.test(email)) {
      invalidFields.push("Email");
    }

    // Validate SSN (if provided)
    if (ssn && !PATTERNS.ssn.test(ssn)) {
      invalidFields.push("SSN");
    }

    // If there are invalid fields, show an alert
    if (invalidFields.length > 0) {
      setInvalidFields(invalidFields);
      Swal.fire({
        title: "Missing or Invalid Fields",
        text: `Please fill out or correct the following fields:\n- ${invalidFields.join(
          "\n- "
        )}`,
        icon: "warning",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      return false; // Indicate invalid form
    }
    return true; // Indicate valid form
  };

  const validatePage2 = () => {

    const REQUIRED_FIELDS = [
    ];

    // Reset invalid fields
    setInvalidFields([]);
    const invalidFields = [];

    // Validate required fields
    REQUIRED_FIELDS.forEach(({ field, label }) => {
      if (!PatientRegistrationFormData[field]?.trim()) {
        invalidFields.push(label);
      }
    });

    // Emergency fields validation
    const {
      emergencyPhone,
      employeeEmail,
      emergencyName,
      emergencyRelationship,
      workphone,
      ssn,
      responsiblePersonSignature
    } = PatientRegistrationFormData;
    const emergencyFields = [
      { value: emergencyName, label: "Emergency Name" },
      { value: emergencyRelationship, label: "Emergency Relationship" },
      { value: emergencyPhone, label: "Emergency Phone" },
    ];

    const filledEmergencyFields = emergencyFields.filter(({ value }) =>
      value?.trim()
    ).length;
    if (
      filledEmergencyFields > 0 &&
      filledEmergencyFields < emergencyFields.length
    ) {
      emergencyFields.forEach(({ value, label }) => {
        if (!value?.trim()) invalidFields.push(label);
      });
    }

    if (PatientRegistrationFormData.isMinor && !responsiblePersonSignature && dept_practice !== "seg") {
      invalidFields.push("Responsible Person Signature");
    }

    // Validate Cell Phone
    if (emergencyPhone && !PATTERNS.phone(emergencyPhone)) {
      invalidFields.push("Emergency Phone");
    }

    if (ssn && !PATTERNS.ssn.test(ssn)) {
      invalidFields.push("SSN");
    }

    // Validate Emergency Phone
    if (workphone && !PATTERNS.phone(workphone)) {
      invalidFields.push("Employee Phone");
    }

    if (employeeEmail && !PATTERNS.email.test(employeeEmail)) {
      invalidFields.push("Employee Email");
    }

    // If there are invalid fields, show an alert
    if (invalidFields.length > 0) {
      setInvalidFields(invalidFields);

      Swal.fire({
        title: "Missing or Invalid Fields",
        text: `Please fill out or correct the following fields:\n- ${invalidFields.join(
          "\n- "
        )}`,
        icon: "warning",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });

      return false; // Indicate invalid form
    }
    return true; // Indicate valid form
  };

  const validatePage3 = () => {
    const missingFields = [];
    const requiredFields = [];
    const { isMinor, patientSignature, responsiblePersonRelationship } = PatientRegistrationFormData;



    /* -------------------------
       SEG PRACTICE VALIDATION
    ------------------------- */
    if (dept_practice === "seg") {

      if (show && !showPatientSignaturePage6) {
        requiredFields.push({
          field: "signatureConsent",
          label: "Agree and sign",
        });
      } else {
        if (!isMinor) {
          requiredFields.push({
            field: "patientSignature",
            label: "Patient's Signature",
          });
        } else {
          requiredFields.push({
            field: "responsiblePersonSignature",
            label: "Responsible Person's Signature",
          });
        }
      }

      // Family members validation
      const result = validateFamilyMembers(
        PatientRegistrationFormData.familyMembers
      );

      if (result) {
        missingFields.push({
          field: "familyMembers",
          label: result,
        });
      }

      // LASIK validation
      const allNull =
        PatientRegistrationFormData.lasik &&
        Object.values(PatientRegistrationFormData.lasik).every(
          (v) => v === null
        );

      if (allNull) {
        missingFields.push({
          field: "lasik",
          label: "Lasik Information",
        });
      }
    }

    /* -------------------------
       RSI PRACTICE VALIDATION
    ------------------------- */
    if (dept_practice === "rsi") {
      if (isMinor && !showPatientSignature) {
        missingFields.push({
          field: "signatureConsent",
          label: "Agree and sign",
        });
      }
      if (isMinor && !responsiblePersonRelationship) {
        requiredFields.push({
          field: "responsiblePersonRelationship",
          label: "Responsible Person's Relationship",
        });
      }

      if (!isMinor && !patientSignature) {
        missingFields.push({
          field: "patientSignature",
          label: "Patient's Signature",
        });
      }
    }

    /* -------------------------
       REQUIRED FIELD CHECK
    ------------------------- */
    requiredFields.forEach(({ field, label }) => {
      if (!PatientRegistrationFormData[field]) {
        missingFields.push({ field, label });
      }
    });

    /* -------------------------
       FINAL VALIDATION RESULT
    ------------------------- */
    if (missingFields.length > 0) {
      setInvalidFields(missingFields.map((f) => f.field));

      Swal.fire({
        title: "Missing or Invalid Fields",
        text: `Please fill out or correct the following fields:\n- ${missingFields
          .map(({ label }) => label)
          .join("\n- ")}`,
        icon: "warning",
        allowOutsideClick: false,
      });

      return false;
    }

    setInvalidFields([]);
    return true;
  };



  const validatePage4 = () => {
    setInvalidFields([]); // Clear previously set invalid fields
    const missingFields = []; // Initialize missingFields array to track invalid fields


    // true if ANY value is null
    const hasNullSymptoms =
      PatientRegistrationFormData.symptoms &&
      Object.values(PatientRegistrationFormData.symptoms).some((v) => v === null);

    const hasNullHistory =
      PatientRegistrationFormData.medicalHistory &&
      Object.values(PatientRegistrationFormData.medicalHistory).some((v) => v === null);

    if (dept_practice === "rsi" && hasNullSymptoms) {
      missingFields.push({
        field: "symptoms",
        label: "Symptoms Information should be completed for all symptoms",
      });
    }
    if (dept_practice === "rsi" && hasNullHistory) {
      missingFields.push({
        field: "medicalHistory",
        label: "Medical History Information should be completed for all diseases",
      });
    }
    // If any fields are invalid or missing, show alert and return false
    if (missingFields.length > 0) {
      // Show an alert with the missing fields
      Swal.fire({
        title: "Missing or Invalid Fields",
        text: `Please fill out or correct the following fields:\n- ${missingFields
          .map(({ label }) => label)
          .join("\n- ")}`,
        icon: "warning",
        allowOutsideClick: false,
      });
      return false;
    }

    // If no invalid or missing fields, clear invalidFields and return true
    setInvalidFields([]);
    return true; // Return true to indicate valid form
  };

  const validatePage5 = () => {
    setInvalidFields([]); // Clear previously set invalid fields
    const missingFields = []; // Initialize missingFields array to track invalid fields

    const requiredFields = [
      // { field: "doctorSignature", label: "Doctor's Signature" },
    ];

    const hasNullFamilyDiseases = PatientRegistrationFormData.familyDiseases &&
      Object.values(PatientRegistrationFormData.familyDiseases).some(
        (disease) => disease.hasDisease === null
      );
    if (hasNullFamilyDiseases) {
      missingFields.push({
        field: "familyDiseases",
        label: "Family Diseases Information should be completed for all diseases",
      });
    }
    if (PatientRegistrationFormData.smoker === true && PatientRegistrationFormData.packsPerDay === "") {
      requiredFields.push({
        field: "packsPerDay",
        label: "Mention number of packets",
      });
    }

    if (PatientRegistrationFormData.pregnant === true && PatientRegistrationFormData.due_date === "") {
      requiredFields.push({
        field: "due_date",
        label: "Mention due date",
      });
    }

    if (
      PatientRegistrationFormData.drinksAlcohol === true &&
      PatientRegistrationFormData.glassesPerDay === ""
    ) {
      requiredFields.push({
        field: "glassesPerDay",
        label: "Mention number of glasses",
      });
    }

    if (!showPatientSignaturePage4) {
      missingFields.push({
        field: "Signature",
        label: "Agree and sign"
      });
    }

    requiredFields.forEach(({ field, label }) => {
      if (!PatientRegistrationFormData[field]) {
        setInvalidFields((prev) => [...prev, field]);
        missingFields.push({ field, label });
      }
    });



    // If any fields are invalid or missing, show alert and return false
    if (missingFields.length > 0) {
      // Show an alert with the missing fields
      Swal.fire({
        title: "Missing or Invalid Fields",
        text: `Please fill out or correct the following fields:\n- ${missingFields
          .map(({ label }) => label)
          .join("\n- ")}`,
        icon: "warning",
        allowOutsideClick: false,
      });

      return false;
    }

    // If no invalid or missing fields, clear invalidFields and return true
    setInvalidFields([]);
    return true;
  };

  const validatePage6 = () => {
    // Reset invalid fields
    setInvalidFields([]);
    const invalidFields = [];


    if (dept_practice === 'rsi') {
      const result = validateFamilyMembers(
        PatientRegistrationFormData.familyMembers
      );
      if (result) {
        invalidFields.push(result);
      }
    }
    if (!showPatientSignaturePage5) {
      invalidFields.push("Agree and Sign")
    }
    if (invalidFields.length > 0) {
      setInvalidFields(invalidFields);

      Swal.fire({
        title: "Missing or Invalid Fields",
        text: `Please fill out or correct the following fields:\n- ${invalidFields.join(
          "\n- "
        )}`,
        icon: "warning",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });

      return false; // Indicate invalid form
    }
    return true; // Indicate valid form
  };

  const validatePage7 = () => {
    setInvalidFields([]); // Clear previously set invalid fields
    const missingFields = []; // Initialize missingFields array to track invalid fields

    const requiredFields = [];
    if (PatientRegistrationFormData.imageConsent === "" && dept_practice === 'rsi') {
      requiredFields.push({
        field: "imageConsent",
        label: "Either agree or disagree",
      });
    }

    if (dept_practice === 'seg' && PatientRegistrationFormData.refractions === null) {
      missingFields.push({
        field: "refractions",
        label: "Prescription for Glasses or Contact Lenses",
      });
    }

    requiredFields.forEach(({ field, label }) => {
      if (!PatientRegistrationFormData[field]) {
        setInvalidFields((prev) => [...prev, field]);
        missingFields.push({ field, label });
      }
    });
    // If any fields are invalid or missing, show alert and return false
    if (missingFields.length > 0) {
      // Show an alert with the missing fields
      Swal.fire({
        title: "Missing or Invalid Fields",
        text: `Please fill out or correct the following fields:\n- ${missingFields
          .map(({ label }) => label)
          .join("\n- ")}`,
        icon: "warning",
        allowOutsideClick: false,
      });

      return false;
    }

    // If no invalid or missing fields, clear invalidFields and return true
    setInvalidFields([]);
    return true;
  };

  const validatePage8 = () => {
    setInvalidFields([]); // Clear previously set invalid fields
    const missingFields = []; // Initialize missingFields array to track invalid fields
    if (dept_practice === 'rsi' && !showPatientSignaturePage6) {
      missingFields.push({
        field: "Signature",
        label: "Agree and sign",
      });
    }

    if (dept_practice === 'seg' && PatientRegistrationFormData.isMinor && !PatientRegistrationFormData.responsiblePersonSignature) {
      missingFields.push({
        field: "Signature",
        label: "Agree and sign",
      });
    }
    else if (dept_practice === 'seg' && !PatientRegistrationFormData.isMinor && PatientRegistrationFormData.patientSignature === "") {
      missingFields.push({
        field: "Signature",
        label: "Agree and sign",
      });
    }

    if (dept_practice === 'seg' && PatientRegistrationFormData.imaging_options === null) {
      missingFields.push({
        field: "imaging_options",
        label: "Imaging Options",
      });
    }

    // If any fields are invalid or missing, show alert and return false
    if (missingFields.length > 0) {
      // Show an alert with the missing fields
      Swal.fire({
        title: "Missing or Invalid Fields",
        text: `Please fill out or correct the following fields:\n- ${missingFields
          .map(({ label }) => label)
          .join("\n- ")}`,
        icon: "warning",
        allowOutsideClick: false,
      });

      return false;
    }

    // If no invalid or missing fields, clear invalidFields and return true
    setInvalidFields([]);
    return true;
  };

  const validateForm = (page) => {
    switch (page) {
      case 0:
        return validatePage1();
      case 1:
        return validatePage2();
      case 2:
        return validatePage3();
      case 3:
        return validatePage4();
      case 4:
        return validatePage5();
      case 5:
        return validatePage6();
      case 6:
        return validatePage7();
      case 7:
        return validatePage8();
      default:
        return false;
    }
  };

  const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

  const shouldSkipPage = (page, data) =>
    (page === 6 && data.imageConsent === "false");

  const SCALE = 0.7; // shrink to fit one page

  async function capturePageAsImage(currentPage) {
    try {
      const node = pageRefs.current[currentPage]?.current;
      if (!node) {
        return;
      }
      if (shouldSkipPage(currentPage, PatientRegistrationFormData)) return;

      // 1️⃣ Wait for images & fonts
      await waitForImages(node);
      await document.fonts.ready;
      await sleep(200); // desktop quirks

      // 2️⃣ Save original styles
      const originalStyle = {
        width: node.style.width,
        height: node.style.height,
        overflow: node.style.overflow,
      };

      // 3️⃣ Force A4 width
      const A4_WIDTH = 1200;
      node.style.width = `${A4_WIDTH}px`;
      node.style.height = "auto";
      node.style.overflow = "visible";

      await sleep(50); // let layout settle

      // 4️⃣ Measure full rendered height (reliable)
      const fullHeight = Math.ceil(node.getBoundingClientRect().height);

      if (fullHeight === 0) {
        console.warn("Warning: node height is 0 — capture may be blank.");
      }

      // 5️⃣ Capture image
      const image = await toJpeg(node, {
        cacheBust: true,
        quality: 0.95,
        backgroundColor: "#FFFFFF",
        width: A4_WIDTH,
        height: fullHeight,
        pixelRatio: Math.min(4, window.devicePixelRatio || 1),
      });

      // 6️⃣ Restore original styles
      node.style.width = originalStyle.width;
      node.style.height = originalStyle.height;
      node.style.overflow = originalStyle.overflow;

      // 7️⃣ Save image in state
      setPages((prev) => {
        const next = [...prev];
        next[currentPage] = image;
        return next;
      });

      return image;
    } catch (error) {
      console.error("Error capturing page:", error);
    }
  }


  const handleNext = async (e) => {
    try {
      e.preventDefault();

      if (!validateForm(currentPage)) {
        return;
      }

      setIsNext(true);
      setNextLoader(true);

      // Save current zoom
      const originalZoom = zoom;

      // Reset zoom to 100% before capture
      setZoom(1);

      // Wait a tick to let the DOM re-render at 100%
      await new Promise((resolve) => setTimeout(resolve, 50));
      await autosave('newregistration', PatientRegistrationFormData);
      // Capture page
      await capturePageAsImage(currentPage);

      // Restore original zoom
      setZoom(originalZoom);

      // Move to next page
      if (show && dept_practice === "seg" && currentPage === 7) {
        setCurrentPage(0);
      }
      else {
        setCurrentPage((prev) => prev + 1);
      }

      setNextLoader(false);
    } finally {
      setIsNext(false);
    }
  };


  const handleEdit = () => {
    setCurrentPage(0);
    setIsDisabled(false); // Enable the form fields
  };

  const handleBackClick = () => {
    if (currentPage === 0 && !show) {
      return;
    }
    else if (show && currentPage === 0) {
      setCurrentPage(7);  // Decrement the current page for pages 2, 3, 4, etc.
    }
    else {
      setCurrentPage(currentPage - 1);  // Decrement the current page for pages 2, 3, 4, etc.

    }
  };


  const handleRemoveFamilyMember = (index) => {
    setPatientRegistrationFormData((prevData) => ({
      ...prevData,
      familyMembers: removeFamilyMember(prevData.familyMembers, index),
    }));
  };

  useEffect(() => {
    const date = PatientRegistrationFormData.dob;
    const state = PatientRegistrationFormData.state;

    const calculateAge = date
      ? new Date().getFullYear() -
      new Date(date).getFullYear() -
      (new Date() <
        new Date(
          new Date(date).setFullYear(new Date().getFullYear())
        )
        ? 1
        : 0)
      : null;

    setAge(calculateAge);

    setPatientRegistrationFormData((prev) => ({
      ...prev,
      age: calculateAge,
    }));

    const isMinor = (state === 'AL' && calculateAge < 19) || (state !== 'AL' && calculateAge < 18);

    setPatientRegistrationFormData((prev) => ({
      ...prev,
      isMinor,
    }));

  }, [PatientRegistrationFormData.dob]);

  const handleFamilyContentChange = (index, field, value) => {

    handleFamilyContentChanges({
      index,
      field,
      value,
      formData: PatientRegistrationFormData,
      setFormData: setPatientRegistrationFormData,
    });
  };


  return (
    <div className="flex justify-center bg-gray-50">
      <div className="min-h-screen flex flex-col bg-white">
        {isLoading3 && <Refresh />}
        {nextLoader && <NextBtnLoader />}
        {isUploading && <Rocket />}
        {isLoading4 && (<Writing />)}

        {
          dept_practice === 'rsi' && (
            <RSIRegistration
              pageTitle={pageTitle}
              Header={Header}
              Back={Back}
              currentPage={currentPage}
              handleBackClick={handleBackClick}
              subPageTitle={subPageTitle}
              PatientRegistrationFormData={PatientRegistrationFormData}
              handleInputChange={handleInputChange}
              isNext={isNext}
              invalidFields={invalidFields}
              handleZipSearch={handleZipSearch}
              languageOptions={languageOptions}
              genderOptions={genderOptions}
              FormHeader={FormHeader}
              FormInput={FormInput}
              TextInput={TextInput}
              pageRefs={pageRefs}
              setPatientRegistrationFormData={setPatientRegistrationFormData}
              SelectInput={SelectInput}
              ImageConsent={ImageConsent}
              Paragraph={Paragraph}
              signatures={signatures}
              canvasRefs={canvasRefs}
              isEditing={isEditing}
              updateSignatureData={updateSignatureData}
              clearSignature={clearSignature}
              toggleEditMode={toggleEditMode}
              MedicalPortalAccess={MedicalPortalAccess}
              isDisabled={isDisabled}
              ethnicityOptions={ethnicityOptions}
              raceOptions={raceOptions}
              maritalOptions={maritalOptions}
              emergencyRelationshipOptions={emergencyRelationshipOptions}
              formattedDate={formattedDate}
              age={age}
              showPatientSignature={showPatientSignature}
              setShowPatientSignature={setShowPatientSignature}
              showPatientSignaturePage4={showPatientSignaturePage4}
              showPatientSignaturePage5={showPatientSignaturePage5}
              showPatientSignaturePage6={showPatientSignaturePage6}
              setShowPatientSignaturePage4={setShowPatientSignaturePage4}
              setShowPatientSignaturePage5={setShowPatientSignaturePage5}
              setShowPatientSignaturePage6={setShowPatientSignaturePage6}
              AssignmentRelease={AssignmentRelease}
              Signature={Signature}
              DisabledTextBox={DisabledTextBox}
              nextLoader={nextLoader}
              ButtonGroup={ButtonGroup}
              handleAddMember={handleAddMember}
              handleFamilyContentChange={handleFamilyContentChange}
              handleRemoveFamilyMember={handleRemoveFamilyMember}
              handleFamilyHistoryChange={handleFamilyHistoryChange}
              handleEdit={handleEdit}
              handleNext={handleNext}
              handlePatientRegistration={handlePatientRegistration}
              handleCheckboxChange={handleCheckboxChange}
              handleCheckChange={handleCheckChange}
              FaPlus={FaPlus}
              FaTrash={FaTrash}
              PrivacyConsent={PrivacyConsent}
              FinancialPolicy={FinancialPolicy}
              DynamicCheckbox={DynamicCheckbox}
              FamilyDiseases={FamilyDiseases}
              DOBPickerInput={DOBPickerInput}
              FamilyMemberConsent={FamilyMemberConsent}
              SymptomCheckboxGroup={SymptomCheckboxGroup}
              isLast={isLast}
              Agree={Agree}
            />
          )}

        {
          dept_practice === 'seg' && (
            <SegRegistration
              pageTitle={pageTitle}
              Header={Header}
              Back={Back}
              currentPage={currentPage}
              handleBackClick={handleBackClick}
              subPageTitle={subPageTitle}
              PatientRegistrationFormData={PatientRegistrationFormData}
              handleInputChange={handleInputChange}
              isNext={isNext}
              invalidFields={invalidFields}
              handleZipSearch={handleZipSearch}
              languageOptions={languageOptions}
              genderOptions={genderOptions}
              FormInput={FormInput}
              TextInput={TextInput}
              pageRefs={pageRefs}
              setPatientRegistrationFormData={setPatientRegistrationFormData}
              DobInput={DobInput}
              SelectInput={SelectInput}
              Paragraph={Paragraph}
              signatures={signatures}
              canvasRefs={canvasRefs}
              isEditing={isEditing}
              updateSignatureData={updateSignatureData}
              clearSignature={clearSignature}
              toggleEditMode={toggleEditMode}
              MedicalPortalAccess={MedicalPortalAccess}
              isDisabled={isDisabled}
              ethnicityOptions={ethnicityOptions}
              raceOptions={raceOptions}
              maritalOptions={maritalOptions}
              emergencyRelationshipOptions={emergencyRelationshipOptions}
              formattedDate={formattedDate}
              age={age}
              showPatientSignature={showPatientSignature}
              setShowPatientSignature={setShowPatientSignature}
              showPatientSignaturePage4={showPatientSignaturePage4}
              showPatientSignaturePage5={showPatientSignaturePage5}
              showPatientSignaturePage6={showPatientSignaturePage6}
              setShowPatientSignaturePage4={setShowPatientSignaturePage4}
              setShowPatientSignaturePage5={setShowPatientSignaturePage5}
              setShowPatientSignaturePage6={setShowPatientSignaturePage6}
              AssignmentRelease={SegAssignmentRelease}
              Signature={Signature}
              DisabledTextBox={DisabledTextBox}
              nextLoader={nextLoader}
              ButtonGroup={ButtonGroup}
              handleAddMember={handleAddMember}
              handleFamilyContentChange={handleFamilyContentChange}
              handleRemoveFamilyMember={handleRemoveFamilyMember}
              handleFamilyHistoryChange={handleFamilyHistoryChange}
              handleEdit={handleEdit}
              handleNext={handleNext}
              handlePatientRegistration={handlePatientRegistration}
              handleCheckboxChange={handleCheckboxChange}
              handleCheckChange={handleCheckChange}
              FaPlus={FaPlus}
              FaTrash={FaTrash}
              FinancialPolicy={SegFinancialPolicy}
              DynamicCheckbox={DynamicCheckbox}
              segLogo={segLogo}
              SegTitle={SegTitle}
              DOBPickerInput={DOBPickerInput}
              formattingDate={formattingDate}
              CheckboxGroup={CheckboxGroup}
              toggleCheckbox={toggleCheckbox}
              SegFooter={SegFooter}
              SegLogoBanner={SegLogoBanner}
              FamilyDiseases={FamilyDiseases}
              show={show}
              ABN={ABN}
              SegimageConsentForm={SegimageConsentForm}
              Head={Head}
              imagingOptions={imagingOptions}
              refractionsOptions={refractionsOptions}
              RadioGroup={RadioGroup}
              FamilyMemberConsent={FamilyMemberConsent}
              SymptomCheckboxGroup={SymptomCheckboxGroup}
              optos={optos}
              optosHeader={optosHeader}
              Logo={Logo}
              Agree={Agree}
            />
          )}

      </div>
    </div>

  );
};

export default PatientRegistrationPageForm;
